import React from "react";

/**
 * DS Tabs — figma 257:1394 "tab" component.
 *
 * 활성 탭: Text/Accent 색상 + border-bottom 3px Accent
 * 비활성 탭: Text/Tertiary
 * 카운트 배지(옵션): BG/Paper pill (radius 999, padding 6×0), SemiBold 14/22 Tertiary
 *
 * 가로 gap: 32px (sapcing-32)
 * 각 탭 padding: 4×16 (px=4, py=16), gap=8 (탭 텍스트 ↔ 카운트 배지)
 *
 * @param {object} props
 * @param {Array<{value: string, label: string, count?: number}>} props.items
 * @param {string} props.activeValue
 * @param {(value: string) => void} props.onChange
 */
const DSTabs = ({ items = [], activeValue, onChange, className = "" }) => {
  return (
    <div className={`ds-tabs ${className}`} role="tablist">
      {items.map((item) => {
        const active = item.value === activeValue;
        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`ds-tabs__item ${active ? "ds-tabs__item--active" : ""}`}
            onClick={() => onChange && onChange(item.value)}
          >
            <span className="ds-tabs__label">{item.label}</span>
            {item.count != null && (
              <span className="ds-tabs__count">{item.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default React.memo(DSTabs);
